import { enableProdMode } from '@angular/core';

import { platformBrowser } from '@angular/platform-browser';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowser()
  .bootstrapModule(AppModule)
  .then(() => {
    if (
      'serviceWorker' in navigator &&
      !window.location.hash.includes('/cleanup')
    ) {
      const idleWorkerUrl = '/idle-session.worker.js';

      fetch(idleWorkerUrl, { cache: 'no-store' })
        .then((response) => {
          if (!response.ok) {
            console.warn(
              'Idle session worker is unavailable. Restart the dev server after asset changes if needed.',
            );
            return null;
          }

          return navigator.serviceWorker.register(idleWorkerUrl, { scope: '/' });
        })
        .catch((error) => {
          console.error('Failed to register idle session worker', error);
        });
    }
  });
